import { INote } from '@/interfaces/noteInterface';

export const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
};

export const cleanContent = (content: string): string => {
  return content
    .split('\n')
    .map(line => line.trim())
    .filter(line => line.length > 0)
    .join('\n');
};

export const transformFieldName = (fieldName: string): string => {
  return fieldName
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, str => str.toUpperCase())
    .replace('Text', '')
    .trim();
};

export const copySection = (key: string, content: string) => {
  const cleanedContent = cleanContent(content?.toString() || '');
  const formattedContent = `${key}:\n${cleanedContent}`;
  copyToClipboard(formattedContent);
};

export const copyAllSections = (noteData: INote | Record<string, unknown>) => {
  const record = noteData as Record<string, unknown>;
  const sections = Object.keys(record)
    .filter(key => record[key] && key.includes('Text'))
    .map(key => {
      const transformedKey = transformFieldName(key);
      const value = record[key];
      const cleanedContent = cleanContent(value != null ? String(value) : '');
      return `${transformedKey}:\n${cleanedContent}`;
    })
    .join('\n\n');
  copyToClipboard(sections);
};

export const COPY_ANIMATION_DURATION = 3000;
